// extracted by mini-css-extract-plugin
export var blockVerticalAdapt = "style-module--block-vertical-adapt--c350b";
export var block__lessonAmount = "style-module--block__lesson-amount--8b0da";
export var block__lessonDuration = "style-module--block__lesson-duration--ff178";
export var block__num = "style-module--block__num--47bba";
export var structure = "style-module--structure--891da";
export var structure__blockBtnWrapper = "style-module--structure__block-btn-wrapper--9994e";
export var structure__blockHeaderRow = "style-module--structure__block-header-row--1af37";
export var structure__blockHeaderTitle = "style-module--structure__block-header-title--5efb4";
export var structure__blockResult = "style-module--structure__block-result--caba4";
export var structure__blockTotal = "style-module--structure__block-total--19a8d";
export var structure__title = "style-module--structure__title--ad28a";